import i18next from 'i18next';

export const validateNotWhitespaceOnly = <T>(value: T): true | string =>
  typeof value === 'string'
    ? value.trim().length > 0 || i18next.t('common:no_whitespaces')?.toString()
    : true;

export const validateFormNumberInput = <T>(value: T): true | string =>
  typeof value === 'string'
    ? value.trim().length > 4 || i18next.t('common:required_field')?.toString()
    : true;
